// @ts-nocheck

import { createSelector } from 'reselect';

import { selectNetwork } from '../../selectors/network/networkPrimary.selector';
import { NetworkStatuses } from '../../types/network';
import { type Selector } from '../../types/selectors';

const selectIsNetworkDisconnected: Selector<boolean> = createSelector(
  [selectNetwork],
  (networkState) => networkState !== NetworkStatuses.CONNECTED,
);

type AppNetworkStatusPropsType = {
  isDisconnected: boolean;
};

const selectAppNetworkStatusProps: Selector<AppNetworkStatusPropsType> = createSelector(
  [selectIsNetworkDisconnected],
  (isDisconnected) => ({
    isDisconnected,
  }),
);

export default selectAppNetworkStatusProps;
